var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.$gettext(_vm.documentType)}},[_c('icon-document',{attrs:{"document-type":_vm.documentType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }